$(document).ready(function(){
    var form = $('form#product-form');
    if ( window.location.hash === "#documentModal")
        $('#documentModal').modal({show: true})

    initProduct(rootUrl);
    hideListProduct();
    typeEssieuxChecked();
    tonnageChecked();
    getClientByNum(rootUrl)
    $("input[name='type_essieux']").on("click", function() {
        typeEssieuxChecked();
    });

    $("input[name='tonnage']").on("click", function() {
        tonnageChecked();
    });
    $("input[name='matriculation']").on("click", function() {
        validateChasis();
    });
    $("input[name='chassis_number']").on("click", function() {
        validateChasis();
    });
});

function validateChasis() {
    const inputs = document.querySelectorAll('input');

    const patterns = {
        matriculation:  /[A-Z]{2}[-][0-9]{3}[-][A-Z]{2}/,
        chassis_number: /[A-Za-z0-9]{8}/
    };

    inputs.forEach((input) => {
        input.addEventListener('keyup', (e) => {
            validate(e.target, patterns[e.target.attributes.id.value]);
        });
    });
}

function validate(field, regex) {
    if(field.name === "matriculation" && field.name === "chassis_number") {
        if (regex?.test(field.value)) {
            field.className = 'form-control valid';
            $('#chassisHelp').addClass('hidden')
            $('#immatriculationHelp').addClass('hidden')
        } else {
            $('#chassisHelp').removeClass('hidden')
            $('#immatriculationHelp').removeClass('hidden')
            field.className = 'form-control invalid';
        }
    }
}

function initProduct(rootUrl){
    $('#product').on("keyup change", function(){
        //var product = $(this).val();
        var product = $('#product').val();
        if(product !== "") {
            $.ajax({
                type:'GET',
                url: rootUrl+'listeproduit',
                data: { universeId: product },
                async: true,
                dataType: 'text',
                contentType: 'application/x-www-form-urlencoded;charset=UTF-8',
                beforeSend:function(xhr){
                    xhr.overrideMimeType('text/html;charset=UTF-8');
                },
                success:function(data, textStatus){
                    $('#listProduit').removeClass('hidden');
                    if(product ==="" || product === undefined) {
                        $('#listProduit').addClass('hidden');
                    }
                    $('#panelProduct').html(data);
                },
                error:function(xhr, textStatus, thrownError){
                }
            });
        } else {
            $('#listProduit').addClass('hidden');
        }

    });
}
function hideListProduct() {
    $('#hideProduct').on("keyup change", function(){
        $('#listProduit').addClass('hidden');
    });
}

function openDocumentAdhesion(e) {
    const templateName = e.substr(0, e.length - 4);
    const productInstanceId = document.getElementById("productInstanceId").value;

    $.ajax({
        url: rootUrl +templateName+'/'+productInstanceId,
        method: 'GET',
        data: {},
        success: function(data) {
            $('#panelAdhesion').html(data);
        },
        error: function (xhr) {
            throw new xhr;
        }
    });
}

function imprimmer(e) {
    const templateId = e.id;
    const productInstanceId = document.getElementById("productInstanceId").value;
    const url = rootUrl +'print/'+templateId+'/'+productInstanceId;
    window.open(url);
}

function typeEssieuxChecked() {
    var typeEssieux = $("input[name='type_essieux']:checked").val();
    if(typeEssieux === "4") {
        $("input[name='type_activite']").each(function() {
            var typeActivite = $(this).val();
            if(typeActivite === '1329') {
                $(this).prop('checked', true);
                $(this).prop("disabled", true);
                kmdurree(typeActivite);
            } else {
                $(this).prop("disabled", true);
            }
        });
    } else {
        $("input[name='type_activite']").each(function() {
            var typeActivite = $(this).val();
            if(typeActivite === '1328') {
                $(this).prop('checked', true);
                $(this).prop("disabled", true);
                kmdurree(typeActivite);
            } else {
                $(this).prop("disabled", true);
            }
        });

    }
}

function tonnageChecked() {
    var tonnage = $("input[name='tonnage']:checked").val();
    if(tonnage === 'autres') {
        $("#tonnage_desc").show();
    } else {
        $("#tonnage_desc").val('');
        $("#tonnage_desc").hide();
    }
}

function kmdurree(typeActivite) {
    $("input[name='durree']").each(function() {
        var durre_km = $(this).val();
        if(typeActivite === '1328') {
            if(durre_km < 1351) {
                $(this).prop('hidden', true);
                $(this).prop('checked', false);
                $(this).prop("disabled", true);
                $("#"+durre_km).hide()
            } else {
                $(this).prop('hidden', false);
                $(this).prop("disabled", false);
                $("#"+durre_km).show()
            }
        } else if(typeActivite === '1329') {
            if(durre_km > 1350) {
                $(this).prop('hidden', true);
                $(this).prop('checked', false);
                $(this).prop("disabled", true);
                $("#"+durre_km).hide()
            } else {
                $(this).prop('hidden', false);
                $(this).prop("disabled", false);
                $('#'+durre_km).show()
            }
        }
    });
}

function getClientByNum(rootUrl) {
    $('#client_num').on("keyup change", function(){
        var numClient = $('#client_num').val();
        var client;
        $.ajax({
            url: rootUrl +'client/'+numClient,
            method: 'GET',
            success: function(data) {
                try {
                    const client = JSON.parse(data)
                    $("#client_name").val(client.client_name).prop("disabled", true)
                    $("#client_address").val(client.client_address).prop("disabled", true)
                    $("#client_zipcode").val(client.client_zipcode).prop("disabled", true)
                    $("#client_city").val(client.client_city).prop("disabled", true)
                    $("#country").val(client.client_country).prop("disabled", true)
                    $("#client_tel").val(client.client_tel).prop("disabled", true)
                    $("#client_email").val(client.client_email).prop("disabled", true)
                } catch (e) {
                    $("#client_name").val('').prop("disabled", false)
                    $("#client_address").val('').prop("disabled", false)
                    $("#client_zipcode").val('').prop("disabled", false)
                    $("#client_city").val('').prop("disabled", false)
                    $("#country").val('').prop("disabled", false)
                    $("#client_tel").val('').prop("disabled", false)
                    $("#client_email").val('').prop("disabled", false)
                }
            },
            error: function (xhr) {
                throw new xhr;
            }
        });
    });
}

function valideContrat(productInstanceId) {
    $.ajax({
        url: rootUrl +'admin/contract/validate/'+productInstanceId,
        method: 'POST',
        data: {},
        success: function(data) {
            document.location.href = rootUrl + 'admin/contracts/validate'
        },
        error: function (xhr) {
            throw new xhr;
        }
    });
}

function deleteContrat(productInstanceId) {
    var verif = confirm("Voulez-vous vraiment supprimer ce contrat ?");
    if(verif) {
        $.ajax({
            type:'GET',
            url: rootUrl+'admin/contract/delete/'+productInstanceId,
            data: {},
            async: true,
            dataType: 'text',
            contentType: 'application/x-www-form-urlencoded;charset=UTF-8',
            beforeSend:function(xhr){
                xhr.overrideMimeType('text/html;charset=UTF-8');
            },
            success:function(data){
                document.location.href = rootUrl+'admin/contracts'
            },
            error:function(xhr, textStatus, thrownError){
                alert("Vous n'avez pas le droit de supprimer ce contrat");
            }
        });
    } else {
        document.location.href = window.location.href
    }

}

function showContrat(productInstanceId) {
    $.ajax({
        type:'GET',
        url: rootUrl+'contract/'+productInstanceId,
        data: {},
        async: true,
        dataType: 'text',
        contentType: 'application/x-www-form-urlencoded;charset=UTF-8',
        beforeSend:function(xhr){
            xhr.overrideMimeType('text/html;charset=UTF-8');
        },
        success:function(data){
            document.location.href = rootUrl+'contract/'+productInstanceId
        },
        error:function(xhr, textStatus, thrownError){
            alert('Erreur AJAX : '+thrownError);
        }
    });
}

function displayConditionCourtier(checkbox) {
    checkbox.checked = false
    $('#coeosCourtierModal').modal({show: true})

}

function displayConditionGeneral() {
    $('#conditionGeneralModal').modal({show: true})
}
function onCheckConditionGeneral(checkbox) {
    if(checkbox.checked === true) {
        $('#conditionGeneralModal').modal({show: true})
        var now = new Date();
        now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
        document.getElementById('dateAcceptConditionGeneral').value = now.toISOString().slice(0,16);
    }
}
function acceptConditionCourtier() {
    $("#coeos-courtier").prop("checked", true)
    var now = new Date();
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
    document.getElementById('dateAcceptConditionCourtier').value = now.toISOString().slice(0,16);
}

function hideConditionGeneral() {
    $('#conditionGeneralModal').modal({show: false})
}
